import AcUnitIcon from '@mui/icons-material/AcUnit'
import BookOnlineIcon from '@mui/icons-material/BookOnline'
import DirectionsCarFilledIcon from '@mui/icons-material/DirectionsCarFilled'
import GridOnIcon from '@mui/icons-material/GridOn'
import WarehouseOutlinedIcon from '@mui/icons-material/WarehouseOutlined'
import React from 'react'
import { StorageLayoutGraphic } from '../StorageLayout'
import {
  UnitsHeroActionGroup,
  UnitsHeroBody,
  UnitsHeroDescription,
  UnitsHeroEyebrow,
  UnitsHeroGraphicColumn,
  UnitsHeroGraphicFrame,
  UnitsHeroGrid,
  UnitsHeroOverlay,
  UnitsHeroPrimaryButton,
  UnitsHeroSecondaryButton,
  UnitsHeroSection,
  UnitsHeroStatCard,
  UnitsHeroStatIcon,
  UnitsHeroStatLabel,
  UnitsHeroStatValue,
  UnitsHeroStats,
  UnitsHeroTextColumn,
  UnitsHeroTitle,
} from '../styled'

const HERO_STATS = [
  {
    label: 'Available now',
    getValue: (availableUnits: number) => `${availableUnits} open units`,
    icon: <WarehouseOutlinedIcon fontSize="small" />,
  },
  {
    label: 'Climate options',
    getValue: (_availableUnits: number, climateCount: number) =>
      `${climateCount} unit styles`,
    icon: <AcUnitIcon fontSize="small" />,
  },
  {
    label: 'Covered storage',
    getValue: (
      _availableUnits: number,
      _climateCount: number,
      coveredCount: number
    ) => `${coveredCount} parking options`,
    icon: <DirectionsCarFilledIcon fontSize="small" />,
  },
]

export const UnitsHero: React.FC<{
  availableUnits: number
  climateCount: number
  coveredCount: number
  onReserve: () => void
  onViewLayout: () => void
}> = ({
  availableUnits,
  climateCount,
  coveredCount,
  onReserve,
  onViewLayout,
}) => (
  <UnitsHeroSection className="units-hero">
    <UnitsHeroOverlay className="units-hero__overlay" />
    <UnitsHeroGrid className="units-hero__grid">
      <UnitsHeroTextColumn className="units-hero__content-column">
        <UnitsHeroBody className="units-hero__content">
          <UnitsHeroEyebrow className="units-hero__eyebrow">
            Available Units in Schulenburg
          </UnitsHeroEyebrow>
          <UnitsHeroTitle className="units-hero__title">
            Storage options presented like a storefront, not a spreadsheet.
          </UnitsHeroTitle>
          <UnitsHeroDescription className="units-hero__description">
            Browse climate-controlled units, everyday storage, and covered
            parking with simple pricing and availability. Pick the size that
            fits your move, business inventory, or vehicle.
          </UnitsHeroDescription>

          <UnitsHeroStats className="units-hero__stats">
            {HERO_STATS.map(({ label, getValue, icon }) => (
              <UnitsHeroStatCard key={label} className="units-hero__stat-card">
                <UnitsHeroStatIcon className="units-hero__stat-icon">
                  {icon}
                </UnitsHeroStatIcon>
                <div className="units-hero__stat-copy">
                  <UnitsHeroStatLabel className="units-hero__stat-label">
                    {label}
                  </UnitsHeroStatLabel>
                  <UnitsHeroStatValue className="units-hero__stat-value">
                    {getValue(availableUnits, climateCount, coveredCount)}
                  </UnitsHeroStatValue>
                </div>
              </UnitsHeroStatCard>
            ))}
          </UnitsHeroStats>

          <UnitsHeroActionGroup className="units-hero__actions">
            <UnitsHeroPrimaryButton
              className="units-hero__action units-hero__action--primary"
              onClick={onReserve}
              variant="contained"
              startIcon={<BookOnlineIcon />}
            >
              Reserve Units
            </UnitsHeroPrimaryButton>
            <UnitsHeroSecondaryButton
              className="units-hero__action units-hero__action--secondary"
              onClick={onViewLayout}
              variant="outlined"
              startIcon={<GridOnIcon />}
            >
              View Storage Layout
            </UnitsHeroSecondaryButton>
          </UnitsHeroActionGroup>
        </UnitsHeroBody>
      </UnitsHeroTextColumn>

      <UnitsHeroGraphicColumn className="units-hero__graphic-column">
        <UnitsHeroGraphicFrame className="units-hero__graphic-frame">
          <StorageLayoutGraphic />
        </UnitsHeroGraphicFrame>
      </UnitsHeroGraphicColumn>
    </UnitsHeroGrid>
  </UnitsHeroSection>
)
